import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { apiCall } from "./calendarUtils";
import { SlotPicker } from "./SlotPicker";

// mode: "reschedule" | "alternative"
export function MoveForm({ token, e, mode, onDone, onCancel, onProposal }) {
  const [slot, setSlot] = useState({ date: e.date, time: "" });
  const [message, setMessage] = useState("");
  const [notify, setNotify] = useState(true);
  const [forceReason, setForceReason] = useState(null);
  const [busy, setBusy] = useState(false);
  const isAlt = mode === "alternative";

  const submit = async (force = false) => {
    setBusy(true);
    try {
      if (isAlt) {
        const r = await apiCall(token, `/calendar/admin/appointments/${e.appointment_id}/alternative`, { method: "POST", body: { ...slot, message } });
        toast.success(r.email_sent ? "Alternativtermin vorgeschlagen – Kunde per E-Mail informiert" : "Alternativtermin gespeichert (E-Mail nicht versendet)");
      } else {
        await apiCall(token, "/admin/proposals", { method: "POST", body: { type: "appointment_reschedule", payload: { appointment_id: e.appointment_id, ...slot, force, notify_customer: notify } } }).then(onProposal);
        toast.success("Vorschau erstellt – bitte prüfen und freigeben");
        return setBusy(false);
      }
      onDone();
    } catch (err) {
      if (!isAlt && err.status === 409 && !err.message.includes("belegt") && !err.message.includes("Vergangenheit")) setForceReason(err.message);
      else toast.error(err.message);
    }
    setBusy(false);
  };

  return (
    <div className="space-y-3" data-testid={`${mode}-form`}>
      <p className="text-sm text-[#A1A1AA]">{isAlt ? "Neuen Termin vorschlagen. Der Kunde kann ihn per E-Mail-Link annehmen oder ablehnen – erst bei Annahme wird er bestätigt." : "Neuen Zeitpunkt wählen. Verfügbarkeit und Regeln werden serverseitig geprüft."}</p>
      <SlotPicker token={token} value={slot} onChange={(v) => { setSlot(v); setForceReason(null); }} duration={e.duration || 60} trainingType={e.training_type} excludeId={e.appointment_id} prefix={mode} />
      {isAlt ? (
        <div>
          <Label className="text-[#A1A1AA] text-xs">Nachricht an den Kunden (optional)</Label>
          <Textarea value={message} onChange={(ev) => setMessage(ev.target.value)} rows={2} className="bg-[#0A0A0A] border-white/20 text-white" data-testid="alternative-message" />
        </div>
      ) : (
        <label className="flex items-center gap-2 text-sm text-white">
          <input type="checkbox" checked={notify} onChange={(ev) => setNotify(ev.target.checked)} data-testid="reschedule-notify" /> Kunden per E-Mail informieren
        </label>
      )}
      {forceReason && (
        <div className="border border-orange-500/50 bg-orange-500/10 p-3 text-sm text-orange-200" data-testid="reschedule-force-box">
          Regelverstoß: {forceReason}
          <Button size="sm" onClick={() => submit(true)} className="ml-3 bg-orange-500 hover:bg-orange-600 text-black rounded-none" data-testid="reschedule-force">Trotzdem verschieben</Button>
        </div>
      )}
      <div className="flex gap-2 justify-end">
        <Button variant="outline" onClick={onCancel} className="border-white/20 text-white rounded-none">Abbrechen</Button>
        <Button onClick={() => submit(false)} disabled={busy || !slot.date || !slot.time} className="bg-[#c1ff72] text-black hover:bg-[#a8e65c] rounded-none" data-testid={`${mode}-submit`}>
          {isAlt ? "Vorschlag senden" : "Vorschau erstellen"}
        </Button>
      </div>
    </div>
  );
}
